import { UserProfile } from '../../domain/models/user.model';
import { AppState } from '../app.state';
export const getCurrentUser = (state: AppState): UserProfile | null =>
  state.user.profile;
export const getUserError = (state: AppState): string | null =>
  state.user.error;
export const getUserLoading = (state: AppState): boolean =>
  state.user.isLoading;
